var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"coords":_vm.coords,"zoom":_vm.zoom,"ymap-class":"map"}},[_vm._l((_vm.routes),function(route){return _vm._l((route.tracks),function(track){return _c('ymap-marker',{key:track.id,attrs:{"marker-id":track.id,"coords":[track.lat, track.lng],"options":{
        iconContentSize: [100, 20],
      },"icon":{
        layout: 'default#imageWithContent',
        imageHref: route.icon,
        imageSize: [20, 20],
        imageOffset: [-10, -10],
        contentOffset: [-40, -20],
        content: ("<span class='content content-" + (route.id) + "'>" + (track.name) + "</span>"),
      }}})})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }